import { Icon, Tooltip } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { HiRefresh } from "react-icons/hi";

import { IconButton } from "../../../../components";
import { useRegenerateEvaluation } from "./useRegenerateEvaluation";

interface RegenerateEvaluationButtonProps {
  callId?: string;
}

const RegenerateEvaluationButton: React.FC<RegenerateEvaluationButtonProps> = ({
  callId,
}) => {
  const { regenerateEvaluation, isRegenerating } = useRegenerateEvaluation();

  const handleRegenerateEvaluation = useCallback(() => {
    if (!callId) {
      return;
    }
    regenerateEvaluation(callId);
  }, [callId, regenerateEvaluation]);

  return (
    <Tooltip
      id="regenerateEvaluation"
      placement="top"
      label="Regenerate evaluation"
    >
      <IconButton
        icon={<Icon as={HiRefresh} width="16px" height="16px" />}
        aria-label="Regenerate evaluation"
        size="xs"
        p="2"
        variant="ghost"
        height="8"
        isLoading={isRegenerating}
        isDisabled={!callId}
        onClick={handleRegenerateEvaluation}
      />
    </Tooltip>
  );
};

export default RegenerateEvaluationButton;
